import Grid from "@mui/material/Grid";
import Popover from "@material-ui/core/Popover";
import { StatusENUM } from "types/common";

type Props = {
  anchorEl: Element | null;
  onClose: () => void;
  onEditClick?: () => void;
  onDisableClinic?: () => void;
  onAddAdminClick?: () => void;
  onDisableUser?: () => void;
  resendInvitation?: () => void;
  status?: string;
  authStatus?: string;
  activationStatus?: string;
};

const OptionsModalBox = ({
  anchorEl,
  onClose,
  onEditClick,
  onDisableClinic,
  onAddAdminClick,
  status,
  activationStatus,
  onDisableUser,
  resendInvitation,
  authStatus,
}: Props) => {
  const callbackWrapper = (callback: (status?: string) => void) => {
    callback();
    onClose();
  };

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: -200,
      }}
    >
      <Grid
        container
        flexDirection="column"
        borderRadius="10px"
        p="14px 20px 20px"
        sx={{ "& > *": { cursor: "pointer" } }}
      >
        {resendInvitation && authStatus !== StatusENUM.registered && (
          <Grid item onClick={() => callbackWrapper(resendInvitation)}>
            {"Send another invite"}
          </Grid>
        )}
        {onDisableUser && (
          <Grid item pt={2} onClick={() => callbackWrapper(onDisableUser)}>
            {status === StatusENUM.disabled ||
            activationStatus === StatusENUM.disabled
              ? "Activate User"
              : "Deactivate User"}
          </Grid>
        )}
        {onEditClick && (
          <Grid item pb={1} onClick={() => callbackWrapper(onEditClick)}>
            Edit
          </Grid>
        )}
        {onAddAdminClick && (
          <Grid item pt={1} onClick={() => callbackWrapper(onAddAdminClick)}>
            Add Clinic Admin
          </Grid>
        )}
        {onDisableClinic && (
          <Grid item pt={2} onClick={() => callbackWrapper(onDisableClinic)}>
            {status === StatusENUM.disabled
              ? "Activate Clinic"
              : "Deactivate Clinic"}
          </Grid>
        )}
      </Grid>
    </Popover>
  );
};

export default OptionsModalBox;
